import { create } from "zustand";

export type PeriodPreset = "7" | "30" | "90" | "all";

// registration — период = когда реферал зарегистрировался,
// completion — период = когда цель выполнена
export type StatisticsMode = "registration" | "completion";

export interface DateRange {
  from: Date;
  to: Date;
}

interface StatisticsPeriodState {
  preset: PeriodPreset;
  // применённый период: именно он уходит в запрос
  customRange: DateRange | null;
  // выбор дат в календаре до нажатия «Показать»
  draftRange: DateRange | null;
  mode: StatisticsMode;
  setPreset: (preset: PeriodPreset) => void;
  setCustomRange: (range: DateRange | null) => void;
  setDraftRange: (range: DateRange | null) => void;
  setMode: (mode: StatisticsMode) => void;
}

export const useStatisticsPeriodStore = create<StatisticsPeriodState>()(
  (set) => ({
    preset: "7",
    customRange: null,
    draftRange: null,
    mode: "registration",
    setPreset: (preset) =>
      set(() => ({ preset, customRange: null, draftRange: null })),
    setCustomRange: (customRange) =>
      set(() => ({ customRange, draftRange: null })),
    setDraftRange: (draftRange) => set(() => ({ draftRange })),
    setMode: (mode) => set(() => ({ mode })),
  })
);
